var Main = require('./Main');
var connect = require('react-redux').connect;
var readerActions = require('../readerActions');
var downloadActions = require('../../download/downloadActions');

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleTableOfContents: () =>  dispatch(readerActions.toggleTableOfContents()),
    setHeadingPositions: (headings) => dispatch(readerActions.setHeadingPositions(headings)),
    toggleFocusMode: () => dispatch(readerActions.toggleFocusMode()),
    chapterToPdf: () => dispatch(downloadActions.chapterToPdf()),
    setScrollPosition: (position) => dispatch(readerActions.setScrollPosition(position)),
    switchVersion: (url) => dispatch(readerActions.fetchPub(url)),
    showPdfProgress: () => dispatch(downloadActions.showPdfProgress()),
    hidePdfProgress: () => dispatch(downloadActions.hidePdfProgress()),
    toggleDownloadDialog: () => dispatch(readerActions.toggleDownloadDialog(false)),
    toggleDownloadDialogFull: () => dispatch(readerActions.toggleDownloadDialog(true))
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reader: state.reader
  }
}



module.exports = connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/modules/reader/components/MainContainer.js